import React from 'react';
import { Link } from 'react-router-dom';

export default function Topbar({ onLogout, children }) {
  return (
    <header className="topbar">
      <Link className="brand brand-sm" to="/" style={{ color: '#2563eb', textDecoration: 'none' }}>admintools</Link>
      <div className="spacer" />
      <Link className="link" to="/">Home</Link>
      <Link className="link" to="/jobs" style={{ marginLeft: 12 }}>Jobs</Link>
      <Link className="link" to="/jobs/new" style={{ marginLeft: 12 }}>New job</Link>
      <Link className="link" to="/logs" style={{ marginLeft: 12 }}>Logs</Link>
      {onLogout && (
        <button className="link danger" onClick={onLogout} style={{ marginLeft: 12 }}>Logout</button>
      )}
      {children}
    </header>
  );
}
